import { useCallback } from "react";
import {
  NavigateOptions,
  To,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

/**
 * A hook that combines useNavigate and useSearchParams to preserve query parameters during navigation.
 * @returns A function that navigates to a new path while preserving all current query parameters
 */
export const useNavigateWithSearchParams = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useCallback(
    (to: To, options?: NavigateOptions) => {
      const queryString = searchParams.toString();
      const newPath = queryString ? `${to}?${queryString}` : to;
      navigate(newPath, options);
    },
    [navigate, searchParams]
  );
};
